
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/available",
      function () {
        return require("private-next-pages/catalog/available.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/available"])
      });
    }
  